import React from "react";

import PageHeading from "2g-page-heading";

import ZadostiOdbaveniWidget from "b2b/components/zadosti-odbaveni-widget/ZadostiOdbaveniWidget";

function ZadostiOdbaveniWidgetExample() {
  return (
    <>
      <PageHeading>ZadostiOdbaveniWidget</PageHeading>
      <div data-testid="ZadostiOdbaveniWidget">
        <ZadostiOdbaveniWidget />
      </div>
    </>
  );
}

export default React.memo(ZadostiOdbaveniWidgetExample);
